<template>
  <shipblu-prompt
    @close="close"
    class="shipment-modal"
    :active.sync="isActive"
    :title="$t(title)"
    :buttons-hidden="true">
    <div v-if="title === 'Location'">
      <div class="mb-4 shadow-drop rounded-lg flex justify-between items-center p-4" v-for="location in product?.locations" :key="location.index">
        <span>{{location.location}}</span>
        <div>
          <span class="text-grey text-lg font-medium"> {{$t('Qty')}}{{': '}}</span>
          <span class="text-blue-100"> {{`[${location.stored_quantity}]`}}</span>
        </div>
      </div>
    </div>
    <div v-else class="border border-solid border-steam rounded-lg p-2">
      <img :src="product?.image" class="block w-full h-full max-h-[600px] m-auto object-contain" :alt="product?.name"/>
    </div>
  </shipblu-prompt>
</template>

<script>
import ShipbluPrompt from '../../../../../layouts/components/ShipBluPrompt.vue'

export default {
  props: {
    active: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      default: () => ({})
    },
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    isActive: {
      get () {
        return this.active
      },
      set (val) {
        this.$emit('update:active', val)
      }
    }
  },
  methods: {
    close () {
      this.$emit('update:active', false)
      this.$emit('close')
    }
  },
  components: {
    ShipbluPrompt
  }
}
</script>